import i18n from "i18next";
import { initReactI18next } from "react-i18next";

async function loadLocale(lng) {
  const res = await fetch(`/locales/${lng}/common.json`);
  if (!res.ok) throw new Error(`Failed to load locale: ${lng}`);
  return res.json();
}

i18n.use(initReactI18next).init({
  lng: "ar",
  fallbackLng: "en",
  interpolation: { escapeValue: false },
  resources: {},
});

export async function setLanguage(lng) {
  const data = await loadLocale(lng);
  i18n.addResourceBundle(lng, "common", data, true, true);
  await i18n.changeLanguage(lng);

  document.documentElement.lang = lng;
  document.documentElement.dir = lng === "ar" ? "rtl" : "ltr";
}

export default i18n;
